// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_IUT","cls2":"ClaimsList-cls2_aVw ClaimsList-cls1_IUT"};